// extracted by mini-css-extract-plugin
module.exports = {"benefits":"Benefits_benefits__HNbqy","content":"Benefits_content__UMOvu","item":"Benefits_item__XO1ys","col":"Benefits_col__6Mp3R","intro":"Benefits_intro__iKWsy"};